import styled from 'styled-components'
import { PersonAvatar, Truncate, WorkspaceLogo } from '@sketch/components'

export const AvatarTooltipWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;

  ${PersonAvatar},
  ${WorkspaceLogo} {
    margin-right: 8px;
  }
`

export const TooltipContentWrapper = styled.div`
  max-width: 180px;
`

export const TooltipContentName = styled(Truncate)`
  margin-right: 4px;
`

export const TooltipPermissions = styled.span`
  color: ${({ theme }) => theme.colors.foreground.primary.B};
  white-space: nowrap;
`
